'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.safeThrow = exports.onload = exports.getValue = exports.i18n = exports.HEXtoRGB = undefined;

var _i18n = require('./i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _onload = require('./onload');

var _onload2 = _interopRequireDefault(_onload);

var _safeThrow = require('./safe-throw');

var _safeThrow2 = _interopRequireDefault(_safeThrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function HEXtoRGB(hex) {
    hex = String(hex || '');
    var rgb = [];
    for (var i = 1, l = hex.length; i < l; i += 2) {
        rgb.push(parseInt(hex.substr(i, 2), 16));
    }
    return rgb;
}

function getValue(val) {
    if (!val) {
        return val;
    }

    if (!val.hasOwnProperty) {
        return val;
    }

    if (!val.hasOwnProperty('notBlank')) {
        return val;
    }

    return val.notBlank ? val.value : undefined;
}

exports.HEXtoRGB = HEXtoRGB;
exports.i18n = _i18n2['default'];
exports.getValue = getValue;
exports.onload = _onload2['default'];
exports.safeThrow = _safeThrow2['default'];